/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Modal, ModalBody, Button } from "reactstrap";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Switch, FormControlLabel } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { LabSelect } from "../../../components/course/select";
import { CustomLabel } from "../../../ui/labels";
import { Container, FormContainer, GridGroup } from "./styles";
import { InputText, InputTextArea, InputTextAreaEditorContainer } from "../../../ui/inputs";
import { ButtonPrimary, SpinnerButtonPrimary } from "../../../ui/buttons";
import { getNotasDePedidoCategory } from "../../../services/notasDePedidoServices";
import useFetcher from "../../../hooks/useFetcher";
import { getUbicacion, postAvisoNP, patchAvisoNp } from "../../../services/avisosNPServices";
import { handleErrors } from "../../../services/handleErrors";
import { customActionsLabels } from "../../../ui/table";
import { templatesAviso } from "./templates";

const createOrUpdateAviso = async (aviso, id) => {
  if (id) {
    const res = await patchAvisoNp(id, aviso);
    return res;
  }
  const res = await postAvisoNP(aviso);
  return res;
};

const RedSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#F0292A",
    "&:hover": {
      backgroundColor: alpha("#F0292A", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
    backgroundColor: "#F0292A",
  },
  // checked
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#34B93D",
    "&:hover": {
      backgroundColor: alpha("#34B93D", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#34B93D",
  },
}));

const ActionLabel = styled(FormControlLabel)(() => ({
  "& .MuiFormControlLabel-label": {
    fontFamily: "Nunito",
    fontSize: "15px",
  },
}));

const AvisoDeEmpleoForm = ({ toggle, isOpen, nota, setNota }) => {
  const avisoInfo = nota.avisoNP;
  const vacantesFromNota = nota.vacantes;
  const notaDePedidoId = nota.id;
  const currentCargo = nota.cargo || "CARGO";
  const { servicio } = nota;
  const [isLoadingEditor, setIsLoadingEditor] = useState(true);

  const [checkedActivo, setCheckedActivo] = useState(!!(avisoInfo && avisoInfo.estado === "Open"));
  const [confirmModal, setConfirmModal] = useState(false);
  const [category, isLoadingCategory] = useFetcher(getNotasDePedidoCategory);
  const industrias = category && category.industria ? category.industria : [];
  const [industriaValue, setIndustriaValue] = useState(null);
  // const [tipoValue, setTipoValue] = useState(null);
  const [provinciaValue, setProvinciaValue] = useState(
    avisoInfo && avisoInfo.ubicacion && avisoInfo.ubicacion.provincia ? { label: avisoInfo.ubicacion.provincia, value: avisoInfo.ubicacion.provincia } : null
  );
  const [ciudades, isLoadingCiudades] = useFetcher(getUbicacion, [{ provincia: provinciaValue && provinciaValue.value }]);
  const [ciudadValue, setCiudadValue] = useState(null);
  const provincias = category && category.provinciasNP ? category.provinciasNP : [];
  const [currentRubro, setCurrentRubro] = useState("RUBRO");

  useEffect(() => {
    if (industriaValue && industriaValue.label) {
      setCurrentRubro(industriaValue && industriaValue.label);
    }
  }, [industriaValue]);

  const handleCheckActivo = () => {
    setCheckedActivo(!checkedActivo);
  };

  const replaceTemplateVariables = (template, cargo, rubro) => {
    return template.replace("<CARGO>", cargo).replace("<RUBRO>", rubro);
  };

  const industriaOptions = industrias
    ? industrias
        .map((e) => {
          return { label: e.descArea, value: e.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const ciudadOptions =
    ciudades && ciudades.ubicacionNP && ciudades.ubicacionNP.length > 0
      ? ciudades.ubicacionNP
          .map((e) => {
            return { label: e.ciudad, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const provinciaOptions = provincias && provincias.type ? provincias.type : [];

  // const tipoOptions = [
  //   { label: "Part Time", value: "Part Time" },
  //   { label: "Full Time", value: "Full Time" },
  // ];

  const getFunctionToFilter = (filter, selected) => {
    if (filter === "industria") {
      setIndustriaValue(selected);
    }
    if (filter === "provincia") {
      setProvinciaValue(selected);
    }
    if (filter === "ciudad") {
      setCiudadValue(selected);
    }
    // if (filter === "tipo") {
    //   setTipoValue(selected);
    // }
  };
  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const formik = useFormik({
    initialValues: {
      descripcion: "",
      notaDePedidoId,
      informacion: "",
      industria: "",
      responsabilidades: "",
      experiencia: "",
      vacantes: vacantesFromNota || null,
      justificacionCambioVacante: "",
      confidencial: false,
      // salarioMin: "",
      // salarioMax: "",
      ubicacionNPId: null,
      industriaNPId: null,
      estado: "",
      tipo: "Full Time",
      encabezado: templatesAviso.encabezado,
      porQueSumarte: "",
      infoLegal: templatesAviso.mensajeLegal,
    },
    onSubmit: async () => {
      setConfirmModal(!confirmModal);
    },

    validationSchema: Yup.object().shape({
      // cargo: Yup.string().required("Este campo es requerido."),
      vacantes: Yup.number()
        .required("Este campo es requerido.")
        .min(1, "El número de vacantes debe ser 1 o más.")
        .integer("El número de vacantes debe ser un número entero."),
      // razonSocial: clienteManual ? Yup.string().required("debe ingresar un cliente.") : null,
    }),
  });

  const handleSaveConfirm = async (form) => {
    form.setSubmitting(true);
    const { values } = form;
    try {
      const avisoToPost = {
        ...values,
        industriaNPId: industriaValue && industriaValue.value,
        industria: industriaValue && industriaValue.label,
        ubicacionNPId: ciudadValue && ciudadValue.value,
        // salarioMax: values.salarioMax ? values.salarioMax.toString() : "",
        // salarioMin: values.salarioMin ? values.salarioMin.toString() : "",
        estado: checkedActivo ? "Open" : "Closed",
        // tipo: tipoValue && tipoValue.value,
      };

      const { message, result } = await createOrUpdateAviso(avisoToPost, avisoInfo ? avisoInfo.idHash : null);
      // se actualiza la info en la NP
      setNota({ ...nota, avisoNP: { ...result, ubicacion: { provincia: provinciaValue && provinciaValue.label, ciudad: ciudadValue && ciudadValue.label } } });
      toast.success(message);
      toggle();
    } catch (error) {
      handleErrors(error, toast.error, null, formik);
    }

    form.setSubmitting(false);
  };

  useEffect(() => {
    if (avisoInfo) {
      formik.setValues(avisoInfo);
      if (industriaOptions && industriaOptions.length > 0) setIndustriaValue(industriaOptions && industriaOptions.find((e) => e.value === avisoInfo.industriaNPId));
      if (ciudadOptions && ciudadOptions.length > 0) setCiudadValue(ciudadOptions && ciudadOptions.find((e) => e.value === avisoInfo.ubicacionNPId));
      // setTipoValue(tipoOptions && tipoOptions.find((e) => e.value === avisoInfo.tipo));
    }
  }, [avisoInfo, isLoadingCategory, isLoadingCiudades]);

  useEffect(() => {
    const template = servicio === 1 ? templatesAviso.descripcionPerm : templatesAviso.descripcionStaffing;
    formik.setFieldValue("descripcion", replaceTemplateVariables(template, currentCargo, currentRubro));
  }, [currentRubro]);

  return (
    <FormContainer>
      <Modal size="lg" isOpen={isOpen}>
        <div className="modal-header w-100 py-2 align-items-center">
          <h5 className="modal-title">Aviso de Empleo</h5>
          <ActionLabel
            control={<RedSwitch color="warning" checked={checkedActivo} onChange={handleCheckActivo} />}
            label={checkedActivo ? "Activo" : "Inactivo"}
            value="Open"
            style={customActionsLabels}
          />
        </div>

        <ModalBody style={{ backgroundColor: "#f8f8f8" }}>
          <Container>
            <form onSubmit={formik.handleSubmit}>
              <GridGroup className="mb-1" style={{ zIndex: 10, position: "relative" }}>
                <div className="mb-1">
                  <CustomLabel>Provincia</CustomLabel>
                  <LabSelect
                    id="provincia"
                    name="provincia"
                    className="w-100"
                    onChange={handleReactSelectChange}
                    value={provinciaValue}
                    placeholder="Seleccionar"
                    isClearable
                    //   isLoading={isLoadingCompanias}
                    //   disabled={isLoadingCompanias || formik.isSubmitting}
                    options={provinciaOptions}
                  />
                </div>

                <div className="mb-1">
                  <CustomLabel>Localidad</CustomLabel>
                  <LabSelect
                    id="ciudad"
                    name="ciudad"
                    className="w-100"
                    onChange={handleReactSelectChange}
                    value={ciudadValue}
                    placeholder="Seleccionar"
                    isClearable
                    isLoading={isLoadingCiudades}
                    isDisabled={ciudadOptions && ciudadOptions.length === 0}
                    options={ciudadOptions}
                  />
                </div>
              </GridGroup>

              <GridGroup className="mb-1" style={{ zIndex: 5, position: "relative" }}>
                <div className="mb-1">
                  <CustomLabel>Rubro</CustomLabel>
                  <LabSelect
                    id="industria"
                    name="industria"
                    className="w-100"
                    onChange={handleReactSelectChange}
                    value={industriaValue}
                    placeholder="Seleccionar"
                    isClearable
                    isLoading={isLoadingCategory}
                    // disabled={isLoadingCompanias || formik.isSubmitting}
                    options={industriaOptions}
                  />
                </div>
              </GridGroup>

              <GridGroup className="mb-1">
                <div className="mb-1">
                  <CustomLabel>Vacantes</CustomLabel>
                  <InputText
                    type="number"
                    id="vacantes"
                    onWheel={(e) => e.target.blur()}
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.vacantes}
                    maxLength={40}
                    // placeholder={formik.errors.cargo && formik.touched.cargo ? formik.errors.cargo : null}
                    // style={formik.errors.cargo && formik.touched.cargo ? { borderBottom: "1px solid red" } : null}
                  />
                  {formik.errors.vacantes && formik.touched.vacantes && (
                    <CustomLabel style={{ color: "red" }} className="input-feedback">
                      {formik.errors.vacantes}
                    </CustomLabel>
                  )}
                </div>
              </GridGroup>

              {vacantesFromNota && vacantesFromNota !== formik.values.vacantes && (
                <div className="mb-1">
                  <CustomLabel htmlFor="justificacionCambioVacante"> Justificación para cambio de vacantes </CustomLabel>
                  <InputTextArea
                    type="text"
                    id="justificacionCambioVacante"
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.justificacionCambioVacante}
                    maxLength={250}
                  />
                </div>
              )}

              <InputTextAreaEditorContainer className="mb-1 normalized_ul">
                <CustomLabel htmlFor="encabezado"> Encabezado </CustomLabel>
                <CKEditor
                  id="encabezado"
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                    toolbar: [],
                    readOnly: true, // Establecer readOnly como true
                  }}
                  data={formik.values.encabezado}
                  onReady={(editor) => {
                    setIsLoadingEditor(false);
                    editor.enableReadOnlyMode("encabezado");
                  }}
                  onChange={(event, editor) => formik.setFieldValue("encabezado", editor.getData())}
                  onBlur={() => formik.setFieldTouched("encabezado")}
                />
              </InputTextAreaEditorContainer>

              <InputTextAreaEditorContainer className="mb-1 normalized_ul">
                <CustomLabel htmlFor="descripcion"> Descripción de la posición </CustomLabel>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                    toolbar: [],
                  }}
                  id="descripcion"
                  data={formik.values.descripcion}
                  onReady={(editor) => {
                    setIsLoadingEditor(false);
                    editor.enableReadOnlyMode("descripcion");
                  }}
                  onChange={(event, editor) => formik.setFieldValue("descripcion", editor.getData())}
                  onBlur={() => formik.setFieldTouched("descripcion")}
                />
              </InputTextAreaEditorContainer>

              <InputTextAreaEditorContainer className="mb-1 normalized_ul">
                <CustomLabel htmlFor="responsabilidades"> ¿Cómo es el día a día de la posición? (Indicar responsabilidades del puesto) </CustomLabel>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                  }}
                  data={formik.values.responsabilidades}
                  onReady={() => setIsLoadingEditor(false)}
                  onChange={(event, editor) => formik.setFieldValue("responsabilidades", editor.getData())}
                  onBlur={() => formik.setFieldTouched("responsabilidades")}
                />
              </InputTextAreaEditorContainer>

              <InputTextAreaEditorContainer className="mb-1 normalized_ul">
                <CustomLabel htmlFor="experiencia"> Tenemos un desafío para quienes (Indicar requisitos del puesto) </CustomLabel>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                  }}
                  data={formik.values.experiencia}
                  onReady={() => setIsLoadingEditor(false)}
                  onChange={(event, editor) => formik.setFieldValue("experiencia", editor.getData())}
                  onBlur={() => formik.setFieldTouched("experiencia")}
                />
              </InputTextAreaEditorContainer>

              <InputTextAreaEditorContainer className="mb-1 normalized_ul">
                <CustomLabel htmlFor="informacion"> Transformá tu talento con nuestra propuesta (Describir la propuesta laboral y condiciones) </CustomLabel>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                  }}
                  data={formik.values.informacion}
                  onReady={() => setIsLoadingEditor(false)}
                  onChange={(event, editor) => formik.setFieldValue("informacion", editor.getData())}
                  onBlur={() => formik.setFieldTouched("informacion")}
                />
              </InputTextAreaEditorContainer>
              <InputTextAreaEditorContainer className="mb-1 normalized_ul">
                <CustomLabel htmlFor="porQueSumarte"> ¿Porqué sumarte? (Incluir beneficios) </CustomLabel>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                  }}
                  data={formik.values.porQueSumarte}
                  onReady={() => setIsLoadingEditor(false)}
                  onChange={(event, editor) => formik.setFieldValue("porQueSumarte", editor.getData())}
                  onBlur={() => formik.setFieldTouched("porQueSumarte")}
                />
              </InputTextAreaEditorContainer>

              <InputTextAreaEditorContainer className="mb-1 normalized_ul">
                <CustomLabel htmlFor="infoLegal"> Info Legal </CustomLabel>
                <CKEditor
                  editor={ClassicEditor}
                  id="infoLegal"
                  config={{
                    removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                    toolbar: [],
                  }}
                  data={formik.values.infoLegal}
                  onReady={(editor) => {
                    setIsLoadingEditor(false);
                    editor.enableReadOnlyMode("infoLegal");
                  }}
                  onChange={(event, editor) => formik.setFieldValue("infoLegal", editor.getData())}
                  onBlur={() => formik.setFieldTouched("infoLegal")}
                  isDisabled
                />
              </InputTextAreaEditorContainer>

              {/* <GridGroup className="mb-1">
                <div className="mb-1">
                  <CustomLabel>Jornada</CustomLabel>
                  <LabSelect
                    id="tipo"
                    name="tipo"
                    className="w-100"
                    onChange={handleReactSelectChange}
                    value={tipoValue}
                    placeholder="Seleccionar"
                    isClearable
                    // isLoading={isLoadingCategory}
                    // disabled={isLoadingCompanias || formik.isSubmitting}
                    options={tipoOptions}
                  />
                </div>
              </GridGroup> */}

              <div className="mb-1">
                <CustomLabel htmlFor="link"> Link a postulación </CustomLabel>
                <a
                  href={avisoInfo && avisoInfo.linkPostulacion ? avisoInfo.linkPostulacion : ""}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "blue" }}
                  className="w-100 text-decoration-none d-block"
                >
                  {avisoInfo && avisoInfo.linkPostulacion ? avisoInfo.linkPostulacion : ""}
                </a>
              </div>

              {/* <div className="mb-1">
                <CustomLabel>Salario</CustomLabel>
                <GridGroup3 className="mb-1">
                  <div className="mb-1">
                    <CustomLabel>Min</CustomLabel>
                    <InputText
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      id="salarioMin"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.salarioMin}
                      maxLength={40}
                      // placeholder={formik.errors.cargo && formik.touched.cargo ? formik.errors.cargo : null}
                      // style={formik.errors.cargo && formik.touched.cargo ? { borderBottom: "1px solid red" } : null}
                    />
                  </div>
                  <div className="mb-1">
                    <CustomLabel>Max</CustomLabel>
                    <InputText
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      id="salarioMax"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.salarioMax}
                      maxLength={40}
                      // placeholder={formik.errors.cargo && formik.touched.cargo ? formik.errors.cargo : null}
                      // style={formik.errors.cargo && formik.touched.cargo ? { borderBottom: "1px solid red" } : null}
                    />
                  </div>

                  <div className="mb-1">
                    <CustomLabel> Confidencial </CustomLabel>
                    <InputCheckboxContainer>
                      <div className="checkbox-wrapper-19">
                        <input
                          type="checkbox"
                          id="confidencial"
                          name="confidencial"
                          disabled={formik.isSubmitting}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          checked={formik.values.confidencial}
                        />
                        <label htmlFor="confidencial" className="check-box" />
                      </div>
                    </InputCheckboxContainer>
                  </div>
                </GridGroup3>
              </div> */}

              <div className="d-flex justify-content-end mt-4">
                <Button style={{ height: "40px" }} className="mr-2" size="sm" color="btn" type="button" onClick={toggle}>
                  Cancelar
                </Button>
                <ButtonPrimary size="sm" className="btn" type="submit" disabled={formik.isSubmitting}>
                  Guardar
                </ButtonPrimary>
              </div>
              <div>
                <Modal isOpen={confirmModal} centered size="sm" style={{ fontFamily: "Nunito" }}>
                  <ModalBody>
                    <p className="text-center mt-3">Estas a punto de guardar los cambios que has realizado. ¿Deseas continuar?</p>
                    <div className=" mt-3 mb-0 d-flex justify-content-end">
                      <Button color="btn-secondary mr-2" onClick={() => setConfirmModal(!confirmModal)}>
                        No
                      </Button>
                      <SpinnerButtonPrimary
                        isLoading={formik.isSubmitting || isLoadingEditor}
                        isDisabled={formik.isSubmitting}
                        style={{ width: "70px", justifyContent: "center" }}
                        type="button"
                        onClick={() => handleSaveConfirm(formik)}
                      >
                        Si
                      </SpinnerButtonPrimary>
                    </div>
                  </ModalBody>
                </Modal>
              </div>
            </form>
          </Container>
        </ModalBody>
      </Modal>
    </FormContainer>
  );
};

export default AvisoDeEmpleoForm;
